<template>
  <Dialog :title="title" :visible.sync="dialogVisible" width="640px">
    <div v-loading="loading" class="student-dialog">
      <el-transfer
        filterable
        v-model="value"
        :data="studentList"
        :titles="['待选人员', '本次加入']"
      ></el-transfer>
    </div>
    <template #footer>
      <el-button
        plain
        round
        size="small"
        type="primary"
        :loading="submitLoading"
        @click="submit"
        >保存</el-button
      >
    </template>
  </Dialog>
</template>
<script>
import { getCourseMembers, updateCourseMembers } from "@/api/course";
import { getStudents } from "@/api/student";
export default {
  name: "StudentDialog",
  data() {
    return {
      studentList: [],
      value: [],
      existingMemberCodes: [],
      dialogVisible: false,
      title: "指定人员",
      courseCode: "",
      loading: false,
      submitLoading: false
    };
  },
  methods: {
    async open(row) {
      this.courseCode = row.courseCode;
      this.dialogVisible = true;
      this.loading = true;
      this.value = [];
      this.studentList = [];
      this.existingMemberCodes = [];
      try {
        const [studentsRes, membersRes] = await Promise.all([
          getStudents({}),
          getCourseMembers({ courseCode: row.courseCode })
        ]);
        const members = membersRes.data || [];
        this.existingMemberCodes = members
          .map(item => item.memberCode)
          .filter(code => code != null && code !== "");
        const joinedSet = new Set(
          this.existingMemberCodes.map(code => String(code))
        );
        const rows = (studentsRes.data && studentsRes.data.rows) || [];
        // 候选列表去掉已加入人员，且不预填到 value
        this.studentList = rows
          .filter(item => !joinedSet.has(String(item.memberCode)))
          .map(item => ({
            key: item.memberCode,
            label: item.name
          }));
        this.value = [];
      } finally {
        this.loading = false;
      }
    },
    async submit() {
      if (this.submitLoading) return;
      this.submitLoading = true;
      try {
        await updateCourseMembers({
          courseCode: this.courseCode,
          memberCodes: [...this.existingMemberCodes, ...this.value]
        });
        this.$message.success("保存成功");
        this.dialogVisible = false;
        this.$emit("success");
      } finally {
        this.submitLoading = false;
      }
    }
  }
};
</script>
<style scoped lang="less">
.student-dialog {
  /deep/ .el-transfer {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Course/StudentDialog.vue